import { _ } from "libs";

import React from "react";
import moment from "moment-timezone";
import { Link } from "react-router-dom";
import { Reservation, Player } from "../types";
import ClubItemMedium from "./items/club/medium";
import CourtItemMedium from "./items/court/medium";
import PlayerItemSmallColumn from "./items/player/smallColumn";
import { formatName } from "../libs/formatName";
import { openPlayerPopup } from "../actions";
import ChatLink from "./chatLink";
import Loader from "./loader";

const ReservationDetail = ({
	reservation,
	onClose,
	cancelReservation,
	editReservation,
	past = false,
	editLoading = false,
	myId,
}: {
	reservation: Reservation;
	onClose: any;
	cancelReservation: any;
	editReservation?: any;
	past?: boolean;
	editLoading?: boolean;
	myId: string;
}) => {
	const timezone = reservation.club.clubInfo.timeZone;
	const date = moment.unix(reservation.startDateTime).tz(timezone);
	const partners: Player[] = [];
	let playerIds: string[] = [];
	let owner: Player;

	reservation.players.forEach(function(player) {
		if (player.playerId !== reservation.ownerId) {
			partners.push(player);
			playerIds.push(player.playerId);
		} else {
			owner = player;
		}
	});

	playerIds = playerIds.filter(id => !!id);

	const duration = (reservation.endDateTime - reservation.startDateTime) / 60;
	let doorLockingCode: any;

	if(reservation.additionalInfos) {
		doorLockingCode = reservation.additionalInfos.find((item) => { return item.key === "reservation_door_pin"; });
	}

	const championship:any = reservation.championship;
	const championshipName = championship ? championship.name : null;
	const championshipLink = championship ? "/championship/" + championship.uuid : null;

	return (
		<div className="detailView">
			<div className="detailHeader">
				<h4>{_("reservationDetail.heading")}</h4>
				<div className="close" onClick={onClose} />
			</div>
			<div className="group">
				<h6>{_("reservationDetail.date.heading")}</h6>
				<div className="strong">
					{date.format("dddd")}, {date.format("MMMM")} {date.format("D")}
				</div>
				<div className="">
					{date.format("HH:mm")}, {_("reservation.duration", duration, { duration })}
				</div>
			</div>
			<div className="group">
				<h6>{_("reservationDetail.club.heading")}</h6>
				<Link to={`/club/${reservation.club.clubInfo.clubId}`}>
					<ClubItemMedium
						name={reservation.club.clubInfo.name}
						meta={reservation.club.clubInfo.address1 + ", " + reservation.club.clubInfo.city}
						photoUrl={reservation.club.clubInfo.photoUrl}
					/>
				</Link>
			</div>
			<div className="group">
				<h6>{_("reservationDetail.court.heading")}</h6>
				<CourtItemMedium court={reservation.court} extraClass="capsule" />
			</div>
			{doorLockingCode && (
				<div className="group">
					<h6>Door Locking Code</h6>
					<div className="item reservationDoorLockingCode capsule">
						<div className="itemBody">
							{doorLockingCode.value}
						</div>
					</div>
				</div>
			)}
			<div className="group">
				<h6>{_("reservationDetail.players.heading")}</h6>
				<div className="playerProfiles">
					<div className="clickable" onClick={() => openPlayerPopup(owner.playerId)}>
						<PlayerItemSmallColumn
							key={owner.playerId}
							name={owner.fullName ? owner.fullName : formatName(owner.firstName, owner.lastName)}
							photoUrl={owner.photoUrl}
							owner={true}
						/>
					</div>
					{partners.map((player, index) =>
						player && player.playerId ? (
							<div className="clickable" onClick={() => openPlayerPopup(player.playerId)} key={index}>
								<PlayerItemSmallColumn
									name={
										player.fullName
											? player.fullName
											: formatName(player.firstName, player.lastName)
									}
									photoUrl={player.photoUrl}
								/>
							</div>
						) : (
							<PlayerItemSmallColumn
								key={index}
								name={player.fullName ? player.fullName : formatName(player.firstName, player.lastName)}
								photoUrl={player.photoUrl}
							/>
						)
					)}
				</div>
			</div>
			{reservation.championship && (
				<div className="group">
					<h6>{_("reservationDetail.championship.heading")}</h6>
					<p>
						<Link to={championshipLink} className="link">
							{championshipName}
						</Link>
					</p>
				</div>
			)}
			<div className="group">
				<h6>{_("reservationDetail.payment.heading")}</h6>
				<div className="item reservationPayment">
					<div className="itemBody">
						<div className="">
							{reservation.paymentDetails.totalCost.toFixed(2)} {reservation.paymentDetails.currency}
						</div>
						<div className="">
							{_("bookingWizard.payment." + reservation.paymentDetails.paymentMethod + ".label")}
						</div>
					</div>
					<div className="itemExtra">
						{reservation.paymentDetails.paid && (
							<div className="badge paid">{_("reservation.paymentStatus.paid")}</div>
						)}
					</div>
				</div>
			</div>
			{reservation.startDateTime > Date.now() / 1000 && (
				<div className="msg info">
					{reservation.conditions.cancelPossible ? (
						<span>
							{_("reservation.canBeCancelledUntil", null, {
								until: moment
									.unix(reservation.conditions.cancelUntil)
									.tz(timezone)
									.format("ddd, D MMMM H:mm"),
							})}
						</span>
					) : (
						<span>{_("reservation.cannotBeCancelled")}</span>
					)}
				</div>
			)}
			<div className="separator" />
			<ul className="actionList">
				{playerIds.length > 0 ? (
					<li>
						<ChatLink
							className="link"
							ownerId={reservation.ownerId !== myId ? reservation.ownerId : null}
							ids={playerIds}
							label={_("reservationDetail.messagePartnerBtn", playerIds.length)}
						/>
					</li>
				) : null}

				{!past && reservation.ownerId === myId ? (
					<li>
						{editLoading ? (
							<Loader text={_("reservationDetail.editReservationBtn")} />
						) : (
							<a
								onClick={() => {
									editLoading ? null : editReservation(reservation);
								}}
								className="link"
							>
								{_("reservationDetail.editReservationBtn")}
							</a>
						)}
					</li>
				) : null}

				{reservation.conditions.cancelPossible ? (
					<li>
						<a
							onClick={() => {
								cancelReservation(reservation.reservationId);
							}}
							className="link"
						>
							{_("reservationDetail.cancelReservationBtn")}
						</a>
					</li>
				) : null}

				{/*!past ? (
					<li>
						<a href="">Add to calendar</a>
					</li>
				) : null*/}

				{/*}
				<li>
					<a href="">Repeat reservation next week</a>
				</li>
				*/}
			</ul>
		</div>
	);
};

export default ReservationDetail;
